module.exports = __webpack_public_path__ + "static/img/SearchLeads.db7e3fb3.png";